import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup,
} from 'devextreme-react/data-grid';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { backendlink } from '../../config';
import './PartnerCustomerListDatagrid.css';

export default function PartnerCustomerListDatagrid() {

    const { user } = useAuth();

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);

    const [formData, setformData] = useState({ startDate: '', endDate: '' });

    function handleRowClick(e) {
        const customerToken = e.data.customerToken;
        navigate('/partner-customer-info', { state: { customerToken: customerToken } });
    }

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await axios.post(backendlink + 'partner/getpartnercustomers',
                {
                    usertoken: user.userToken
                },
                {
                    headers: {
                        token: user.token
                    }
                });
                if (response.data.errorno === 0) {
                    const outputArray = response.data.result[0].map(item => {
                        var statusString = (item.isEnabled === true ? 'Active' : 'Inactive')

                        return { customerName: item.companyname, customerID: item.id, status: statusString, linkedPartner: item.partnerName, address: item.companyaddress, contactPerson: item.contactperson, phone: item.phone, email: item.email, customerToken: item.userToken };
                    });
                    setUsers(outputArray)
                }
                else if (response.data.errorno === 330) {
                    setUsers([])
                }
                else {
                    alert(response.data.errmessage);
                }
            } catch (error) {
                alert(error);
            }
        };

        fetchData();

        var dateStartdate = new Date(Date.now() - 86400000)
        var dateEnddate = new Date()

        setformData({ startDate: dateStartdate, endDate: dateEnddate })
    }, [user]);

    return (
        <React.Fragment>
            <DataGrid dataSource={users} onRowClick={handleRowClick}>
                <Column dataField='customerID' caption='Organization ID' alignment='left' filterOperations={["contains"]}/>
                <Column dataField='customerName' caption='Organization Name' filterOperations={["contains"]}/>
                <Column dataField='address' caption='Company Address' filterOperations={["contains"]}/>
                <Column dataField='contactPerson' caption='Contact Person' filterOperations={["contains"]}/>
                <Column dataField='phone' caption='Phone Number' filterOperations={["contains"]}/>
                <Column dataField='email' caption='Contact Email' filterOperations={["contains"]}/>

                <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
                <Paging defaultPageSize={5} />
                <FilterRow visible={true} />
                <Lookup />
            </DataGrid>
        </React.Fragment>
    )

}
